import { render, staticRenderFns } from "./MainSliderPhoto.vue?vue&type=template&id=e99a91c8"
import script from "./MainSliderPhoto.vue?vue&type=script&lang=js"
export * from "./MainSliderPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports